var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from "react";
import { selectors, useAppSelector } from "store";
import { imageSelectOptions } from "store/system-data/helpers";
import { CustomImageSelect } from "ui/components/elements/input/image-select";
export var ApplicationSelect = function (_a) {
    var onSelectApplication = _a.onSelectApplication, onConfirmApplication = _a.onConfirmApplication, withConfirmButton = _a.withConfirmButton, initialValue = _a.initialValue;
    var _b = __read(useState(initialValue || ""), 2), selectedApplication = _b[0], setSelectedApplication = _b[1];
    var selectApplicationParameter = useAppSelector(selectors.selectSelectApplicationParameter);
    var onValueChange = useCallback(function (value) {
        setSelectedApplication(value);
        onSelectApplication && onSelectApplication(value);
    }, [onSelectApplication]);
    if (!selectApplicationParameter) {
        return null;
    }
    var options = imageSelectOptions(selectApplicationParameter);
    return (_jsx(CustomImageSelect, { withConfirmButton: withConfirmButton, value: selectedApplication, items: options.items, itemLabels: options.itemLabels, itemImages: options.itemImages, onValueChange: onValueChange, onConfirmChoice: onConfirmApplication, description: selectApplicationParameter.description }));
};
